import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SearchSubProject from '../../components/forms/searchSubProject/SearchSubProject'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import { getSummarizeformFormReportSubmitPdf } from '../../redux/actions/subProjectReport'

export default function SummaryReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [previewPdf, setPreviewPdf] = useState()
  const [subProjectOption, setSubProjectOption] = useState([])

  useEffect(() => {
    console.log('load ProjectName projectId')
    formSchema.buttonText.previewButtonName = 'แสดงตัวอย่างก่อนพิมพ์'
    buttonDisabled()
  }, [])

  const buttonDisabled = () => {
    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      subProjectOption: formSchema.searchObject.subProjectOption.disabled,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }

    setDisableValue(disValue)
  }

  const handleDownloadPdf = async (data) => {
    await handleCallReportSubmitPdf(data.subProjectOption)
    await onDownload(previewPdf)
  }

  const onDownload = async (fileObj) => {
    if (fileObj) {
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.fileName || `รายงานสรุปเพื่อขออนุมัติ`)
      document.body.appendChild(link)
      link.click()
    }
  }

  const handleCheangMainProject = (projectId) => {
    const subProject = formSchema.valuesObject.mainProject.find(
      (mainProject) => mainProject.value === projectId
    )
    setSubProjectOption(subProject.subProject)

    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      subProjectOption: false,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }
    setDisableValue(disValue)
  }

  const handleChangeSubProject = (data) => {
    const disValue = {
      buttonText: false,
      subProjectOption: false,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }
    setDisableValue(disValue)
  }

  const handleCancel = () => {
    setIsSucceed(false)
    setPreviewPdf(null)
    for (const key in getValues()) {
      setValue(key, null)
    }
    buttonDisabled()
  }

  const handlePreviewPdf = async (data) => {
    await handleCallReportSubmitPdf(data.subProjectOption)
    setIsSucceed(true)
  }

  const handleCallReportSubmitPdf = async (subProjectId) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)

    try {
      const response = await getSummarizeformFormReportSubmitPdf(subProjectId)

      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error(e)
      setIsPdfError(true)
    }

    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <SearchSubProject
            schema={formSchema}
            subProjectOption={subProjectOption}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onChangeMainProject={handleCheangMainProject}
            onChangeSubProject={handleChangeSubProject}
            disabledValue={disabledValue}
          />
        )}

        <hr />

        <ButtonPanelWidget
          isDisabled={disabledValue.buttonText}
          isEdit={isEdit}
          isError={isError}
          buttonText={formSchema.buttonText}
          onPrint={handleSubmit(handleDownloadPdf)}
          onPreview={handleSubmit(handlePreviewPdf)}
          onCancel={(el) => {
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>

      <br />

      {isSucceed && (
        <Panel
          shaded
          header={formSchema.reportName}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <>
              <PdfRenderWidgets
                isShaded={false}
                file={previewPdf}
                isLoading={isLoadingPDF}
                isShowbutton={false}
                onReload={() => handleGetProjectSubmitPdf(projectId)}
              />
            </>
          )}
        </Panel>
      )}
    </>
  )
}
